import { createFileRoute } from '@tanstack/react-router'

import RewardPage from '@/views/loyalty/reward/reward.page'

export const Route = createFileRoute('/_layout/loyalty/reward')({
  component: RewardPage,
})
